// extracted by mini-css-extract-plugin
export var modal = "_bw-0";